var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_201994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2423 1.58545H5.50743C5.25802 1.58545 5.13529 1.88893 5.31472 2.06231L11.1819 7.73092C11.2895 7.83476 11.4599 7.83476 11.5674 7.73092L17.435 2.06227C17.6144 1.88897 17.4917 1.58545 17.2423 1.58545Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82241 7.76505L3.66075 2.7781C3.53469 2.65635 3.32878 2.68052 3.23436 2.82809L0.0441696 7.81499C-0.0739347 7.99962 0.0586549 8.24182 0.277845 8.24182H8.62966C8.87902 8.24187 9.00174 7.93834 8.82241 7.76505Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7056 7.81506L19.5154 2.82811C19.421 2.6805 19.2151 2.65637 19.089 2.77808L13.927 7.76503C13.7476 7.93832 13.8703 8.24189 14.1197 8.24189H22.4719C22.6911 8.24184 22.8236 7.99968 22.7056 7.81506Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2654 9.90625H0.488859C0.247763 9.90625 0.121438 10.1927 0.284065 10.3707L10.0606 21.0734C10.2314 21.2603 10.5428 21.1395 10.5428 20.8863V10.1836C10.5427 10.0304 10.4186 9.90625 10.2654 9.90625Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2613 9.90625H12.4844C12.3312 9.90625 12.207 10.0304 12.207 10.1836V20.8867C12.207 21.1399 12.5184 21.2607 12.6892 21.0738L22.4662 10.3707C22.6287 10.1926 22.5025 9.90625 22.2613 9.90625Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_201994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.75,
    height: 22.75
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.dec4226de9ee94d106fb4a20e69773a1.svg";
export { ForwardRef as ReactComponent };